import { RootPage } from '../page';
import $api from '../../api';
import getHashOrDefault from '../../utils/getHashOrDefault';
import TourPerformanceView from './components/tours/tourPerformanceView';
import ContextHelpsPerformanceView from './components/context-helps/performanceView';
import ChangelogsPerformanceView from './components/changelogs/performanceView';
import ChecklistsPerformanceView from './components/checklists/checklistPerformanceView';
import EventsPerformanceView from './components/events/eventsPerformanceView';
import ArticlesPerformanceView from './components/articles/articlesPerformanceView';
import Pager from '../../components/pager';
import { getTours, getContextHelps, getChecklists } from './core';
import { prepareSerializedDateRange, serializeDateRange } from '../../utils/dateRanges';

class InsightsPerformanceView extends RootPage {
    constructor() {
        super();

        this.deferUpdates = true;

        Pager();
        TourPerformanceView(this);
        ChangelogsPerformanceView(this);
        ContextHelpsPerformanceView(this);
        ChecklistsPerformanceView(this);
        EventsPerformanceView(this);
        ArticlesPerformanceView(this);

        this.tabsUseHashes = true;

        this.setActiveTab(getHashOrDefault('tours'));

        this.toursSelectedTour = ko.observable();
        this.hintsSelectedHint = ko.observable();
        this.checklistsSelectedChecklist = ko.observable();

        this.globalDateRange = ko.observableArray(prepareSerializedDateRange('insights_daterangepicker_saved'));
        this.globalDateRange.subscribe(val => {
            serializeDateRange('insights_daterangepicker_saved', val);
        });
    }

    onInit() {
        this.tours = ko.observableArray(getTours());
        if (this.tours().length > 0) {
            this.toursSelectedTour(this.tours()[0].id);
        }

        this.hintGroups = ko.observableArray(getContextHelps());
        if (this.hintGroups().length > 0) {
            this.hintsSelectedHint(this.hintGroups()[0].id);
        }

        this.checklists = ko.observableArray(getChecklists());
        if (this.checklists().length > 0) {
            this.checklistsSelectedChecklist(this.checklists()[0].id);
        }
    }
}

export default InsightsPerformanceView;